
import { ProductBatchDto, ProductType } from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase } from './api'

export type ProductBatchsFilters = PaginatedQueryBase & {
  search?: string
  storageLocationId?: string
  productGenericName?: string
  productCatalogId?: string
  productType?: ProductType
  inStock?: boolean
}

class ProductBatchService extends BaseCrudService<
  ProductBatchDto,
  {},
  {},
  ProductBatchsFilters
> {
  constructor() {
    super('product-batch', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }
}

export const productBatchService = new ProductBatchService()
